<template>
    <div>
        <button class="button" id="open-dialog-map">{{ $t('projectmap.label.filtersort') }}</button>               
        <dialog id="dialog-map">
            <button class="close-button" id="close-dialog-map">
                <span class="show-for-sr">Schließen</span>
                <span aria-hidden="true">x</span>
            </button>
    
            <h6 class="u-extra-medium-margin--top">{{ $t('projectmap.label.filtersort') }}</h6>

            <v-project-map-asphalt-sort-checkbox-item 
                v-for="(object, index) in layerFilterItemsCheckboxes"
                :key="index"
                :asphaltType="object"
                @activeChanged="onChangeFilterLayers">
            </v-project-map-asphalt-sort-checkbox-item>
        </dialog>
     </div>
</template>

<script>
import ProjectMapAsphaltSortCheckboxItem from "./ProjectMapAsphaltSortCheckboxItem";

export default {
  name: "ProjectMapAsphaltSoftFilter",
  
  props: {
     filteredProjects: Array,
     resetLayerFilter: Boolean
  },
  data: function () {
    return {
      layerTypes: this.$helpers.layertypes,
      layerFilterItems: [],
      layerFilterItemsCheckboxes: {},
      selectedLayerTypes: [],
    };
  },

  async mounted() {
    this.prepareLayerFilterData();
    this.updateLayerFilterCheckboxes();
    this.asphaltsorteDialogWindow();
  },

  components: {
    vProjectMapAsphaltSortCheckboxItem: ProjectMapAsphaltSortCheckboxItem
  },
  
  watch: {
    filteredProjects () {
      this.updateLayerFilterCheckboxes();
    },
    resetLayerFilter (value) {
        if(value === true) {
            window.app.$helpers.logger('Resetting checkboxes');
            this.selectedLayerTypes = [];
            this.layerFilterItems = [];
            this.prepareLayerFilterData();
            this.updateLayerFilterCheckboxes();
            // reset our value
            this.resetLayerFilter = false;
            this.$emit('onResetDialogResults', false);
        }
    },
      
  },

  methods: {
    
    /**
     * Opens and closes the Asphaltsorte 
     */
    asphaltsorteDialogWindow: function () {
        const dialog = document.querySelector('#dialog-map');
        const showDialog = document.querySelector('#open-dialog-map');
        const closeDialog = document.querySelector('#close-dialog-map');

        showDialog.addEventListener('click', () => {    
            dialog.showModal();
        });
        closeDialog.addEventListener('click', () => {    
            dialog.close();
        });
    },
    
    /**
     * Gets our global layer informaton and 
     * prepares the data for the filter dialog
     * transforms data for the layerFilterItems array
     */
    prepareLayerFilterData: function () {
      if (Object.keys(this.layerTypes).length >= 1) {
        for (const [key, value] of Object.entries(this.layerTypes)) {
          for (const [k, v] of Object.entries(value)) {
            this.layerFilterItems.push({
                'name' : v.title,
                'active': false,
                'disabled': false,
            });
          }
        }
      }
    },

    
    /**
     * 
     * @param {String} value the name of the layer to filter by the layer name
     * @returns: an array of mapOutputItem objects
     */
    filterLayers: function (value) {
        if (value == "") return;
        // Find all project items that contain at least one of the selected value
        let outputItems = this.filteredProjects.filter((project) => {
            if (project.lat !== null && project.lon !== null) {
                if (Object.keys(project.layers).length >= 1) {
                    for (const [key, val] of Object.entries(project.layers)) {
                        if (val.subtype === value) {
                            return true;
                        }
                    }
                }
            }
        });
        return outputItems;
    },
    
    
    /**
     * Update Layer Filter Checkboxes
     * Checks if we have projects with the layer type and sets disabled attribute
     * if we do not have projects for that layer.
     */
    updateLayerFilterCheckboxes () {
        this.layerFilterItemsCheckboxes = [];
        this.layerFilterItemsCheckboxes = this.layerFilterItems.filter(layerType => {
            const foundProjects = this.filterLayers(layerType.name);
            if (foundProjects.length > 0){
                 layerType.disabled = false;
            }else{
                layerType.disabled = true;
            }
            layerType.active = !!this.selectedLayerTypes.find(selectedLayerType => {
                return selectedLayerType.name === layerType.name;
            })
            // some method call to get active state of layerType
            
            return layerType;
        });
    },
    
    /**
     * Listener attached to the filter checkboxes
     */
    onChangeFilterLayers (asphaltType) {
        asphaltType.active
        ? this.selectFilterLayerByName(asphaltType)
        : this.unselectFilterLayerByName(asphaltType)
    },
    
    /**
     * Adds selected filter to our reactive array of items that 
     * should be shown in the map.
     * @param {Object} asphaltTypeName the name of the filter to select
     */
    selectFilterLayerByName (asphaltType) {
       this.selectedLayerTypes.push({active: true, name: asphaltType.name})
       this.$emit('selectedLayersChanged', this.selectedLayerTypes);
    },
    
    /**
     * Removes selected filter from our reactive array of items that 
     * should be shown in the map.
     * @param {Object} asphaltTypeName Refreshing the filter layer
     */
    unselectFilterLayerByName (asphaltType) {
        this.selectedLayerTypes = this.selectedLayerTypes.filter(layerType => {
            return layerType.name !== asphaltType.name
        });
        this.$emit('selectedLayersChanged', this.selectedLayerTypes);
    },
  },
};
</script>
